import {
    type UpdateAnnouncementResponseType,
    type UpdateAnnouncementRequestType
} from "./type";
import {
    request
} from "../request";

const UpdateAnnouncement = async (params: UpdateAnnouncementRequestType): Promise<UpdateAnnouncementResponseType> => {
    return await request<UpdateAnnouncementResponseType>("/announcement/updateAnnouncement", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default UpdateAnnouncement;
